import React from 'react';
import './TopMenu.scss';
import { useSelector } from 'react-redux';
import { FaHome, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useGetRestaurantByIdQuery } from '../../store/restaurant/restaurantApi';
import { selectSelectedRestaurantId } from '../../store/auth/selectors';

export const TopMenu = (): JSX.Element => {
	const selectedRestaurantId = useSelector(selectSelectedRestaurantId);
	const { data: restaurant } = useGetRestaurantByIdQuery(selectedRestaurantId, { skip: !selectedRestaurantId });
	const navigate = useNavigate();
	const { logout } = useAuth0();

	const handleNavigateHomeClicked = (): void => {
		navigate('/home');
	};

	return (
		<div className="topMenuContainer">
			<div className="restaurantLogo">
				<img src="/images/hetziTuki.png" alt="Restaurant Logo" />
			</div>
			<div className="restaurantInfo">
				<h1 className="restaurantName">{restaurant?.name}</h1>
				<div className="restaurantAddressContainer">
					<p className="restaurantAddress">יוחנן הורקנוס 3, ירושלים</p>
				</div>
			</div>
			<div className="backHome">
				<div className="topMenuIcon" onClick={(): void => logout()}>
					<FaSignOutAlt />
				</div>
				<FaHome onClick={handleNavigateHomeClicked} />
			</div>
		</div>
	);
};
